module.exports = __webpack_public_path__ + "img/logo_shlb.d6c7e806.png";